import React from "react";

import TabPanel from "components/ApiTabPanel/ApiTabPanel";
import CodeCard from "components/shared/CodeCard.js";
import ApiAttribute from "components/ApiAttribute/ApiAttribute";

export function TabPanelRead(props) {
  const { name, friendlyName, value } = props;
  return (
    <TabPanel value={value} index={3}>
      <div style={{ width: "66%" }}>
        <h3>Read</h3>
        <p>
          Returns a single {friendlyName.toLowerCase()} object if a valid id is
          provided.
        </p>
        <CodeCard>GET /api/v2/{name.toLowerCase()}/:id</CodeCard>
        <p>Example:</p>
        <CodeCard>GET /api/v2/{name.toLowerCase()}/123</CodeCard>
        {name === "Item" && (
          <>
            <br />
            <h3>Arguments</h3>
            <p>
              Query parameters can be used as follows. All parameters are
              optional.
            </p>
            <ApiAttribute
              name={"location"}
              type={"string"}
              description={
                "The location filter will reflect the inventory quantity values for the provided location."
              }
            />
          </>
        )}
      </div>
    </TabPanel>
  );
}
